import React from 'react';
import '../NewsScroll.css';

const ARTICLES = [
  {
    source: 'earthjustice.org',
    title: 'Suing xAI over illegal gas power plant at Memphis data center',
    blurb: '~50 unpermitted natural-gas turbines run 24/7. Residents describe the sound as a jet engine or leaf blower that never stops.',
    location: 'Memphis, TN',
    url: 'https://earthjustice.org/case/xai-illegal-gas-power-plant-data-center-colossus',
    type: 'lawsuit',
  },
  {
    source: 'boston.com',
    title: "Lowell residents file Massachusetts' first lawsuit against a data center",
    blurb: '27 diesel generators and 16 cooling towers leave the facility "so loud it can sound like a jet engine," residents say.',
    location: 'Lowell, MA',
    url: 'https://www.boston.com/news/local-news/2026/05/07/lowell-residents-file-massachusetts-first-lawsuit-against-a-data-center/',
    type: 'lawsuit',
  },
  {
    source: 'boston.com',
    title: 'Mansfield becomes first town in Mass. to pass near-total ban on data centers',
    blurb: 'Noise is capped at 50 dBA during the day and 45 dBA at night, about the sound of a refrigerator hum.',
    location: 'Mansfield, MA',
    url: 'https://www.boston.com/news/local-news/2026/05/13/mansfield-becomes-first-town-in-mass-to-pass-near-total-ban-on-data-centers/',
    type: 'moratorium',
  },
  {
    source: 'azfamily.com',
    title: 'Chandler unanimously votes against proposed AI data center',
    blurb: '"We already have real issues with neighborhoods along Dobson who can hear a constant humming from the 160 acres of data centers we already have."',
    location: 'Chandler, AZ',
    url: 'https://www.azfamily.com/2025/12/12/chandler-unanimously-votes-against-proposed-ai-data-center/',
    type: 'denial',
  },
  {
    source: 'whro.org',
    title: 'Chesapeake City Council rejects data center proposal',
    blurb: 'The biggest worry was around-the-clock noise from generators and HVAC, especially low frequencies that penetrate into homes.',
    location: 'Chesapeake, VA',
    url: 'https://www.whro.org/business-growth/2025-06-17/chesapeake-city-council-rejects-data-center-proposal',
    type: 'denial',
  },
  {
    source: 'bisnow.com',
    title: 'Amazon data center project rejected in Northern Virginia as local pushback intensifies',
    blurb: 'Amazon requested a noise waiver for continuous 65 dBA emissions from three 95-ft data centers near two schools.',
    location: 'Prince William Co., VA',
    url: 'https://www.bisnow.com/national/news/data-center/amazon-data-center-project-rejected-in-northern-virginia-as-local-pushback-intensifies-112239',
    type: 'abandoned',
  },
  {
    source: 'datacenterdynamics.com',
    title: "Peculiar officials remove data centers from ordinance, blocking $1.5bn Diode project",
    blurb: 'Generator and cooling fan noise was cited as a key harm to adjacent residents, prompting the city to rewrite its zoning code to exclude data centers entirely.',
    location: 'Peculiar, MO',
    url: 'https://www.datacenterdynamics.com/en/news/peculiar-officials-in-missouri-remove-data-centers-from-ordinance-blocking-15bn-diode-project/',
    type: 'abandoned',
  },
  {
    source: 'kpbs.org',
    title: 'Imperial Valley city sues to force environmental review of massive data center',
    blurb: "The city's 231-page complaint alleges the county illegally bypassed environmental review of noise, air, and safety impacts from the facility's gas generator bank.",
    location: 'Imperial County, CA',
    url: 'https://www.kpbs.org/news/environment/2025/12/12/imperial-valley-city-sues-to-force-environmental-review-of-massive-data-center-project',
    type: 'lawsuit',
  },
  {
    source: 'wsbtv.com',
    title: 'Residents sue county over $17B data center',
    blurb: 'Residents cite diesel backup generators running "around the clock" and construction blasting that caused ground vibrations damaging neighboring water wells.',
    location: 'Coweta Co., GA',
    url: 'https://www.wsbtv.com/news/local/residents-sue-county-government-developer-over-17b-data-center-construction/FJP7PCHLCNCYBGQ6HGGQJWABSE/',
    type: 'lawsuit',
  },
  {
    source: 'fortune.com',
    title: 'A Michigan farm town voted down a giant OpenAI-Oracle data center. Then the developer sued.',
    blurb: 'After the township denied rezoning, the developer sued for "exclusionary zoning." The eventual settlement included mandatory noise caps and water-use limits.',
    location: 'Saline Township, MI',
    url: 'https://fortune.com/2026/05/06/ai-data-center-michigan-saline-politics-farmland/',
    type: 'lawsuit',
  },
  {
    source: 'wvlt.tv',
    title: 'Knox County considers strict noise limits on data centers',
    blurb: 'Proposed caps: 67 dB weekdays 7am–8pm, 57 dB overnight and weekends, with mandatory acoustic studies before construction and again six months after opening.',
    location: 'Knox Co., TN',
    url: 'https://www.wvlt.tv/2026/05/08/knox-county-consider-limits-data-centers-noise-looks-utilities/',
    type: 'ordinance',
  },
  {
    source: 'wwmt.com',
    title: 'Class-action lawsuit filed over hyperscale data center noise in Dowagiac',
    blurb: '"It\'s almost like having a vacuum cleaner running all the time." Neighbors report 60–70 dB continuously since the facility opened in 2022.',
    location: 'Dowagiac, MI',
    url: 'https://wwmt.com/news/local/lawsuit-hyperscale-data-center-dowagiac-noise-class-action-business-center-legal-osha-decibels-contained-digital-asset-mining-facility-rural-southwest-michigan-infrastructure',
    type: 'lawsuit',
  },
  {
    source: 'wral.com',
    title: 'Tarboro Town Council rejects data center plan amid environmental, community concerns',
    blurb: 'Cooling and generator noise was repeatedly cited at public hearings; more than 700 residents signed a petition before the council voted 6–1 to deny the permit.',
    location: 'Tarboro, NC',
    url: 'https://www.wral.com/news/local/tarboro-town-council-rejects-data-center-plan-environmental-community-concerns-sept-2025/',
    type: 'denial',
  },
  {
    source: 'nbcwashington.com',
    title: 'Sterling residents worry about health impact of constant data center noise',
    blurb: '"There was this constant, just like a buzzing in your head… this is just not pleasant to listen to every day, all day." — Sterling resident Lindsay Shaw.',
    location: 'Loudoun Co., VA',
    url: 'https://www.nbcwashington.com/news/local/northern-virginia/amid-constant-data-center-noise-sterling-residents-also-worry-about-health-impact/4091393/',
    type: 'nuisance',
  },
  {
    source: 'nbcnews.com',
    title: "Musk's AI power plant generates sound and fury in Mississippi",
    blurb: 'After residents complained of jet-engine roar from 50 unpermitted gas turbines, xAI installed a $7M sound wall that neighbors dubbed "the Temu sound wall."',
    location: 'Southaven, MS',
    url: 'https://www.nbcnews.com/news/us-news/musks-ai-power-plant-generates-sound-fury-mississippi-rcna258594',
    type: 'lawsuit',
  },
];

/*
 * Two tones, not six. `hot` marks outcomes that actually stopped or penalized a
 * project — the ones that cost money. Everything else is muted, so the strip
 * reads as one field with a few hot points rather than a bag of colors.
 */
const TYPE_CONFIG = {
  lawsuit:    { label: 'Lawsuit',         tone: 'hot' },
  moratorium: { label: 'Moratorium',      tone: 'hot' },
  denial:     { label: 'Permit denied',   tone: 'hot' },
  abandoned:  { label: 'Project blocked', tone: 'hot' },
  ordinance:  { label: 'Ordinance',       tone: 'cool' },
  nuisance:   { label: 'Noise complaint', tone: 'cool' },
};

function NewsCard({ article }) {
  const { source, title, blurb, location, url, type } = article;
  const badge = TYPE_CONFIG[type] || { label: type, tone: 'cool' };

  return (
    <a
      className="news-card"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      <div className="news-card-source">
        <img
          className="news-card-favicon"
          src={`https://www.google.com/s2/favicons?domain=${source}&sz=32`}
          alt=""
          width={16}
          height={16}
        />
        <span className="news-card-domain">{source}</span>
      </div>
      <p className="news-card-title">{title}</p>
      <p className="news-card-blurb">{blurb}</p>
      <div className="news-card-footer">
        <span className="news-card-location">{location}</span>
        <span className={`news-card-badge news-card-badge--${badge.tone}`}>
          {badge.label}
        </span>
      </div>
    </a>
  );
}

function NewsScroll() {
  const doubled = [...ARTICLES, ...ARTICLES];

  return (
    <div className="news-scroll-section">
      <div className="wrap news-scroll-header">
        <span className="eyebrow news-scroll-eyebrow">In the news</span>
        <span className="news-scroll-subtitle">
          Datacenter noise opposition &middot; lawsuits &middot; legislation
        </span>
      </div>
      <div className="news-scroll-outer">
        {/* Duplicated once so the marquee's -50% translate loops seamlessly. */}
        <div className="news-track">
          {doubled.map((article, i) => (
            <NewsCard key={i} article={article} />
          ))}
        </div>
      </div>
      <p className="news-scroll-hint">Hover to pause &middot; click to read</p>
    </div>
  );
}

export default NewsScroll;
